//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = "/prototype/accounting/general-ledger/reports";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    return {
      filterKey: "",
      pageNumber: 0,
      incomeStart: moment().startOf("month"),
      incomeEnd: moment().startOf("month"),
      income: [],
      expense: [],
      rehab: [],
      headers: [],
      totals: [],
      collections: [],
      max5000AccountParentName: "",
      loading: true,
      expenseRow: false,
      incomeRow: false,
      rehabRow: false
    };
  },
  created: function created() {
    Event.$on("gl-income-statement-report", this.glIncomeStatementReport);
    Event.$on("exportIncomeStatementToExcel", function () {
      return alert("export");
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("exportIncomeStatementToExcel");
  },

  methods: {
    glIncomeStatementReport: function glIncomeStatementReport(incomeStart, incomeEnd) {
      this.$children[0].showModal = true;

      if (incomeStart && incomeEnd) {
        this.incomeStart = incomeStart;
        this.incomeEnd = incomeEnd;
      }

      this.load();
    },
    applyFilter: function applyFilter() {
      this.load();
    },
    showGlDetails: function showGlDetails(evt, account, month) {
      Event.$emit('close-full-modal');
      Event.$emit(evt, account, month, this.incomeStart, this.incomeEnd);
    },
    load: function load() {
      var _this = this;

      if (this.incomeStart > this.incomeEnd) {
        this.$snotify.warning("The start date must be before the end date.");
        return;
      }
      this.loading = true;
      axios.post(BASE_URL + "/income-statement", {
        periodStart: this.incomeStart,
        periodEnd: this.incomeEnd
      }).then(function (response) {
        if (response.data) {
          _this.headers = response.data.header;
          _this.totals = response.data.total;
          _this.collections = response.data.collection;
          _this.max5000AccountParentName = response.data.max5000AccountParentName;
          _this.loading = false;
        }
      }).catch(function (err) {
        _this.loading = false;
        _this.snotify.error("Failed to load Income Statement");
        console.log(err);
      });
    },
    exportToExcel: function exportToExcel() {
      this.loading = true;

      var data = {
        periodStart: this.incomeStart, //@TODO: normalize these to start_date, end_date
        periodEnd: this.incomeEnd,
        start_date: this.incomeStart,
        end_date: this.incomeEnd,
        exportExcel: true
      };

      this.createExport(data, BASE_URL + "/income", "income-statement", ".xlsx");

      this.loading = false;
    },
    exportToPdf: function exportToPdf() {
      this.loading = true;

      var data = {
        periodStart: this.incomeStart, //@TODO: normalize these to start_date, end_date
        periodEnd: this.incomeEnd,
        start_date: this.incomeStart,
        end_date: this.incomeEnd,
        exportPdf: true
      };

      this.createExport(data, BASE_URL + "/income", "income-statement", ".pdf");

      this.loading = false;
    }
  },
  computed: {
    totalIncome: function totalIncome() {
      var amount = 0;
      this.income.map(function (account) {
        amount += Number(account.transactionTotal);
      });
      return amount;
    },
    totalExpense: function totalExpense() {
      var amount = 0;
      this.expense.map(function (account) {
        amount += Number(account.transactionTotal);
      });
      return amount;
    },
    totalRehab: function totalRehab() {
      var amount = 0;
      this.rehab.map(function (account) {
        amount += Number(account.transactionTotal);
      });
      return amount;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/reports/GlIncomeStatementReport.vue
// module id = k2gj
// module chunks = 0 1